module.exports = __webpack_public_path__ + "img/listNone.008803d2.png";